const MerchantListView = () =>
  import('@/views/Merchants/MerchantListView/MerchantListView.vue')
const MerchantDetailView = () =>
  import('@/views/Merchants/MerchantDetailView/MerchantDetailView.vue')
const DownPaymentView = () =>
  import('@/views/Merchants/DownPaymentView/DownPaymentView.vue')
const PaymentReportView = () =>
  import('@/views/Reports/TransactionReportView/TransactionReportView.vue')
const PaymentRequestReportView = () =>
  import('@/views/Reports/PaymentRequestReportView.vue')
const ProjectionReportView = () =>
  import('@/views/Reports/ProjectionReportView.vue')
const MerchantCreateView = () =>
  import('@/views/Merchants/MerchantCreateView/MerchantCreateView')
const MerchantSettings = () =>
  import('@/views/Merchants/MerchantSettingsView/MerchantSettingsView.vue')
const ReconciliationDiff = () =>
  import('@/views/Reports/Reconciliation/ReconciliationDiff/ReconciliationDiff.vue')
const FailedActionsView = () =>
  import('@/views/Reports/FailedActions/FailedActions.vue')
const PromiseReportView = () =>
  import('@/views/Reports/PromiseReportView/PromiseReportView.vue')
const FollowUpReportView = () =>
  import('@/views/Reports/FollowUpReportView/FollowUpReportView.vue')
const MessageReportView = () =>
  import('@/views/Reports/MessageReportView/MessageReportView.vue')
const MessageReportDetails = () =>
  import('@/views/Reports/MessageReportView/MessageReportDetails.vue')

const AchReturnReportView = () =>
  import('@/views/Reports/AchReturnReportView/AchReturnReportView.vue')

const AutopayFailuresReport = () =>
  import('@/views/Reports/AutopayFailures/AutopayFailures.vue')

const DMSNotificationsReport = () =>
  import('@/views/Reports/DMSNotificationsReport/DMSNotificationsReport.vue')

const MerchantCollectionStatsView = () =>
  import('@/views/Reports/MerchantCollectionStatsView/MerchantCollectionStatsView.vue')

const PayoutReportView = () =>
  import('@/views/Reports/PayoutReport/PayoutReport.vue')

const OptOutReportView = () =>
  import('@/views/Reports/OptOutReport/OptOutReport.vue')
const UndeliverableReportView = () =>
  import('@/views/Reports/UndeliverableReport/UndeliverableReport.vue')

const AiReportView = () =>
  import('@/views/Reports/AiReportView/AiReportView.vue')

const AiCollectorDashboard = () =>
  import('@/views/Reports/AiCollectorView/AiCollectorView.vue')

const BlytzCollectConfigsView = () =>
  import('@/views/BlytzCollect/BatchConfigListView.vue')

const BlytzCollectBatchRunsView = () =>
  import('@/views/BlytzCollect/BatchRunsView.vue')

const BlytzCollectConfigFormView = () =>
  import('@/views/BlytzCollect/BatchConfigFormView.vue')

const BlytzCollectAnalyticsView = () =>
  import('@/views/Reports/BlytzCollectAnalytics/BlytzCollectAnalyticsView.vue')

import settingRoutes from '@/router/settings/setting-routes'

export default [
  { path: '/merchants', component: MerchantListView, name: 'MerchantList' },
  {
    path: '/merchants/create',
    component: MerchantCreateView,
    name: 'MerchantCreate'
  },
  {
    path: '/merchants/:merchantID',
    component: MerchantDetailView,
    name: 'MerchantDetail'
  },
  {
    path: '/merchants/:merchantID/misc-payment/**',
    component: DownPaymentView,
    name: 'DownPaymentView'
  },
  {
    path: '/merchants/:merchantID/settings/',
    component: MerchantSettings,
    children: [...settingRoutes]
  },
  {
    path: '/payment-report',
    meta: {
      require_custom_roles: [
        'super_admin',
        'admin',
        'is_merchant_payment_report_allowed'
      ],
      require_roles: ['super_admin', 'admin', 'staff']
    },
    component: PaymentReportView,
    name: 'PaymentReport'
  },
  {
    path: '/payment-request-report',
    component: PaymentRequestReportView,
    name: 'PaymentRequestReport'
  },
  {
    path: '/projection-report',
    meta: {
      require_roles: ['super_admin', 'admin', 'staff']
    },
    component: ProjectionReportView,
    name: 'ProjectionReport'
  },
  {
    path: '/merchants/:merchantID/reconciliation',
    component: ReconciliationDiff,
    name: 'Reconciliation'
  },
  {
    path: '/merchants/:merchantID/failed-actions',
    component: FailedActionsView,
    name: 'FailedActions'
  },
  {
    path: '/promises',
    component: PromiseReportView,
    name: 'PromiseReportView'
  },
  {
    path: '/follow-up-report',
    component: FollowUpReportView,
    name: 'FollowUpReportView'
  },
  {
    path: '/ach-return',
    meta: {
      require_roles: ['super_admin', 'admin']
    },
    component: AchReturnReportView,
    name: 'AchReturnReportView'
  },
  {
    path: '/message-report',
    component: MessageReportView,
    name: 'MessageReportView'
  },
  {
    path: '/message-report/:messageID/details',
    component: MessageReportDetails,
    name: 'MessageReportDetail'
  },
  {
    path: '/:merchantID/autopay-failures',
    component: AutopayFailuresReport,
    name: 'AutopayFailures'
  },
  {
    path: '/:merchantID/dms-notification-report',
    component: DMSNotificationsReport,
    name: 'DMSNotificationsReport',
    meta: {
      require_roles: ['super_admin', 'admin']
    }
  },
  {
    path: '/:merchantID/merchant-collection-stats',
    component: MerchantCollectionStatsView,
    name: 'MerchantCollectionStats',
    meta: {
      require_roles: ['super_admin', 'admin']
    }
  },
  {
    path: '/payout-report',
    component: PayoutReportView,
    name: 'PayoutReport'
  },
  {
    path: '/opt-out-report',
    component: OptOutReportView,
    name: 'OptOutReport'
  },
  {
    path: '/undeliverable-report',
    component: UndeliverableReportView,
    name: 'UndeliverableReport'
  },
  {
    path: '/ai-texts-report',
    meta: {
      require_roles: ['super_admin', 'admin']
    },
    component: AiReportView,
    name: 'AiTextsReport'
  },
  {
    path: '/blytzcollect',
    component: AiCollectorDashboard,
    name: 'BlytzCollect'
  },
  {
    path: '/blytzcollect/configs',
    component: BlytzCollectConfigsView,
    name: 'BlytzCollectConfigs',
    meta: {
      require_roles: ['super_admin', 'admin']
    }
  },
  {
    path: '/blytzcollect/configs/new',
    component: BlytzCollectConfigFormView,
    name: 'BlytzCollectConfigCreate',
    meta: {
      require_roles: ['super_admin', 'admin']
    }
  },
  {
    path: '/blytzcollect/configs/:configID/edit',
    component: BlytzCollectConfigFormView,
    name: 'BlytzCollectConfigEdit',
    meta: {
      require_roles: ['super_admin', 'admin']
    }
  },
  {
    path: '/blytzcollect/batch-runs',
    component: BlytzCollectBatchRunsView,
    name: 'BlytzCollectBatchRuns'
  },
  {
    path: '/blytzcollect/analytics',
    component: BlytzCollectAnalyticsView,
    name: 'BlytzCollectAnalytics'
  }
]
